export default function HeaderPO({
  isLatestPONumber,
  isViewMode,
  downloadPDF,
  isPOData,
}) {
  return (
    <div className=" p-5 bg-white">
      <div className="flex gap-6 md:flex-row md:justify-between bg-white">
        <div
          style={{
            background: "#009eff",
            height: "140px",
            width: "150px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src="/assests/pixell white logo.png"
            alt="pixell Logo"
            width={70}
            height={70}
          />
        </div>

        <div className="text-left md:text-right">
          <h1 className="text-2xl font-bold">Purchase Order</h1>

          <h1 className="mt-14 text-2xl font-bold">{isPOData?.po_number}</h1>
        </div>
      </div>
    </div>
  );
}
